import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Accordion } from 'react-bootstrap-5';

import { startsWith, get, find } from 'lodash';
import LocationPanel from './location_panel';
import LocationsEmptySection from './locations_empty_section';
import { DEFAULT_LOCATION, NEW_LOCATION_ID_PREFIX } from './locations_constants';

const LocationsSection = ({ fullWidthMap, locations = [], onLocationsChange, stateOptions, googleMapsApiKey }) => {
  const [expandedLocationId, setExpandedLocationId] =
    useState(get(locations, '[0].id', DEFAULT_LOCATION.id));

  const handleEditLocationField = (locationId, value, key) => {
    handleEditLocation(locationId, {
      [key]: value
    });
  };

  const handleEditLocation = (locationId, value) => {
    const locationToUpdate = find(locations, location => location.id === locationId);
    const locationToUpdateIndex = locations.indexOf(locationToUpdate);
    const newLocation = {
      ...locationToUpdate,
      ...value
    };
    const newLocations = [...locations];
    newLocations[locationToUpdateIndex] = newLocation;

    onLocationsChange(newLocations);
  };

  const handleAddLocation = () => {
    const newLocationId = `${NEW_LOCATION_ID_PREFIX}-${locations.length}`;

    onLocationsChange([
      ...locations,
      {
        ...DEFAULT_LOCATION,
        id: newLocationId
      }
    ]);
    setExpandedLocationId(newLocationId);
  };

  const handleRemove = (locationToRemoveId) => {
    if (startsWith(locationToRemoveId, NEW_LOCATION_ID_PREFIX)) {
      onLocationsChange([
        ...locations.filter(loc => loc.id !== locationToRemoveId)
      ]);
    } else {
      handleEditLocationField(locationToRemoveId, true, '_destroy');
    }
  };

  const visibleLocations = locations.filter(location => !location._destroy);

  return <>
    <Accordion
      activeKey={expandedLocationId}
      className="border"
      id="location-panels"
      onSelect={setExpandedLocationId}
    >
      {visibleLocations
        .map(location => (
          <LocationPanel
            fullWidthMap={fullWidthMap}
            googleMapsApiKey={googleMapsApiKey}
            isOpen={expandedLocationId == location.id}
            key={location.id}
            location={location}
            stateOptions={stateOptions}
            onLocationChange={newLocation => handleEditLocation(location.id, newLocation)}
            onRemove={handleRemove}
          />
        ))}
    </Accordion>

    {visibleLocations.length <= 0 && <LocationsEmptySection />}

    <div className="clickable" name="add-location-btn" onClick={handleAddLocation}>
      + Add More locations
    </div>
  </>;
};

LocationsSection.propTypes = {
  fullWidthMap: PropTypes.bool,
  googleMapsApiKey: PropTypes.string.isRequired,
  locations: PropTypes.array.isRequired,
  stateOptions: PropTypes.array.isRequired,
  onLocationsChange: PropTypes.func.isRequired,
};

export default LocationsSection;
